import React from 'react';

import CenterBlock from '../../shared/components/CenterBlock';

const NotFound = () => <CenterBlock title={'messages.404'} linkTo={'Go to home page'} />;

export default NotFound;
